// guide.js
import introJs from 'intro.js';
import 'intro.js/introjs.css';      // can be global, but local import works too

const shownSteps = new Set(JSON.parse(localStorage.getItem('shown_steps') || '[]'));

export function runTutorial(rawSteps) {
    // 1️⃣ only keep the steps that are still unseen  _and_ whose element exists
    const stepsToShow = rawSteps
        .filter(step => !shownSteps.has(step.key))
        .map(step => ({
            ...step,
            element:
                typeof step.element === 'string'
                    ? document.querySelector(step.element)     // resolve selector
                    : step.element,
        }))
        .filter(step => step.element);                   // drop missing nodes

    if (!stepsToShow.length) return;                  // nothing left to show

    const intro = introJs();
    intro.setOptions({ steps: stepsToShow });

    // 2️⃣ remember completed steps
    const remember = () => {
        stepsToShow.forEach(s => shownSteps.add(s.key));
        localStorage.setItem('shown_steps', JSON.stringify([...shownSteps]));
    };

    intro.oncomplete(remember);
    intro.onexit(remember);

    intro.start();
}
